// extracted by mini-css-extract-plugin
module.exports = {"leftArrow":"styles_leftArrow__2hTav"};